const getCacheSafeFile = path => {
    // refresh once every hour
    const version = Math.floor(Date.now() / 1000 / 60 / 60)
    return `${path}?v=${version}`
}

export default getCacheSafeFile
